import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { requestCloseModal } from "@/redux/actions/modal";
import { setProcessingState } from "@/redux/reducers/modalConfirmation";
import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";

const requestLenderParametersUpdate = lenderService.injectEndpoints({
  endpoints: builder => ({
    requestLenderParametersUpdate: builder.mutation({
      query(id) {
        return {
          url: `lenders/${id}/programs/update-request`,
          method: "POST",
        };
      },
      invalidatesTags: (result, type, id) => [
        { type: LENDER_SERVICE_TAG, id: LIST_SERVICE_TAG },
        { type: LENDER_SERVICE_TAG, id },
      ],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          dispatch(setProcessingState(true));

          const { data } = await queryFulfilled;

          sendAnalytics(ANALYTIC_EVENTS.BROKER_REQUESTED_LENDER_PARAMETERS_UPDATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Lender has been notified!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(requestCloseModal());
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
        } catch (err) {
          Bugsnag.notify(err);
          dispatch(setProcessingState(false));
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useRequestLenderParametersUpdateMutation } = requestLenderParametersUpdate;

